module.exports = __webpack_public_path__ + "img/loaderV6_darkMode.e05bc114.gif";